import React from 'react';
import toast from 'react-hot-toast';
import { Check, Trash2, Camera, Square, Radio, Wifi, Volume2, Monitor, Circle } from 'lucide-react';

const iconOpts = { size: 18 };
const successIcon = React.createElement(Check, iconOpts);
const deleteIcon = React.createElement(Trash2, iconOpts);

/**
 * Utilidad para mostrar notificaciones toast modernas y consistentes
 */

// Notificaciones de éxito
export const showSuccess = (message: string) => {
  toast.success(message);
};

// Notificaciones de error
export const showError = (message: string) => {
  toast.error(message);
};

// Notificaciones de carga
export const showLoading = (message: string) => {
  return toast.loading(message);
};

// Cerrar notificación específica
export const dismissToast = (toastId: string) => {
  toast.dismiss(toastId);
};

// Notificaciones específicas para Inventario de Cámaras
export const notifications = {
  cameras: {
    created: () => toast.success('Cámara agregada al inventario', { icon: React.createElement(Camera, iconOpts) }),
    updated: () => toast.success('Cámara actualizada correctamente', { icon: successIcon }),
    deleted: () => toast.success('Cámara removida del inventario', { icon: deleteIcon, duration: 2500 }),
    activated: () => toast.success('Cámara activada', { icon: successIcon }),
    deactivated: () => toast.success('Cámara desactivada', { icon: React.createElement(Circle, iconOpts) }),
    error: (action: string, detail?: string) => toast.error(detail || `Error al ${action} la cámara`, { duration: 5000 }),
  },
  
  buttons: {
    created: () => toast.success('Botón agregado al inventario', { icon: React.createElement(Square, iconOpts) }),
    updated: () => toast.success('Botón actualizado correctamente', { icon: successIcon }),
    deleted: () => toast.success('Botón removido del inventario', { icon: deleteIcon }),
    error: (action: string, detail?: string) => toast.error(detail || `Error al ${action} el botón`, { duration: 5000 }),
  },
  
  miniot: {
    created: () => toast.success('MinIoT agregado al inventario', { icon: React.createElement(Radio, iconOpts) }),
    updated: () => toast.success('MinIoT actualizado correctamente', { icon: successIcon }),
    deleted: () => toast.success('MinIoT removido del inventario', { icon: deleteIcon }),
    error: (action: string, detail?: string) => toast.error(detail || `Error al ${action} el MinIoT`, { duration: 5000 }),
  },
  
  routers: {
    created: () => toast.success('Router agregado al inventario', { icon: React.createElement(Wifi, iconOpts) }),
    updated: () => toast.success('Router actualizado correctamente', { icon: successIcon }),
    deleted: () => toast.success('Router removido del inventario', { icon: deleteIcon }),
    error: (action: string, detail?: string) => toast.error(detail || `Error al ${action} el router`, { duration: 5000 }),
  },
  
  sirenas: {
    created: () => toast.success('Sirena agregada al inventario', { icon: React.createElement(Volume2, iconOpts) }),
    updated: () => toast.success('Sirena actualizada correctamente', { icon: successIcon }),
    deleted: () => toast.success('Sirena removida del inventario', { icon: deleteIcon }),
    error: (action: string, detail?: string) => toast.error(detail || `Error al ${action} la sirena`, { duration: 5000 }),
  },
  
  xtamVideo: {
    created: () => toast.success('Xtam Video agregado al inventario', { icon: React.createElement(Monitor, iconOpts) }),
    updated: () => toast.success('Xtam Video actualizado correctamente', { icon: successIcon }),
    deleted: () => toast.success('Xtam Video removido del inventario', { icon: deleteIcon }),
    error: (action: string, detail?: string) => toast.error(detail || `Error al ${action} el Xtam Video`, { duration: 5000 }),
  },
  
  // Notificaciones genéricas
  generic: {
    saved: () => toast.success('Cambios guardados correctamente'),
    deleted: () => toast.success('Elemento eliminado'),
    loading: (message: string = 'Cargando...') => toast.loading(message),
    error: (message?: string) => toast.error(message || 'Ocurrió un error'),
  },
};

// Helper para notificaciones con contexto
export const notifyWithContext = (
  type: 'success' | 'error',
  action: string,
  item?: string
) => {
  const message = item ? `${item} ${action}` : action;
  if (type === 'success') {
    toast.success(message);
  } else {
    toast.error(message);
  }
};
